<template>
    <component :is="dynamicComponent" v-bind="$props" v-on="$listeners" :key="`${block.id}-${block.type}`"/>
</template>

<script>
// cms-block-renderer #hot-reload-debug
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";

export default {
    name: `cms-block-renderer`,
    extends: CmsBlock,
    data() {
        return {
            componentCache: {}
        };
    },
    computed: {
        dynamicComponent() {
            const type = this.block.type;
            return () => import(`@/components/editor/rendering/blocks/cms-block-${type}.vue`);
        }
    }
}
</script>

<style scoped lang="scss">
</style>
